import { TranslationObject } from '../../i18n/translation';

const namespace = 'practiceactivity/vurdering';

const translations: TranslationObject = {
  dropdownLabel: {
    id: `${namespace}.dropdownLabel`,
    nb: 'Velg hvilken samling av vurderingskriterier som skal benyttes',
    en: 'Choose which set of evaluation criteria to use',
  },
  dropdownPlaceholder: {
    id: `${namespace}.dropdownPlaceholder`,
    nb: 'Velg en samling av vurderingskriterier',
    en: 'Choose a set of evaluation criteria',
  },
  vurderingskriteriumsamlingCreateSuccess: {
    id: `${namespace}.vurderingskriteriumsamlingCreateSuccess`,
    nb: 'Samling av vurderingskriterier opprettet',
    en: 'Set of evaluation criteria created',
  },
  vurderingskriteriumsamlingEditSuccess: {
    id: `${namespace}.vurderingskriteriumsamlingEditSuccess`,
    nb: 'Samling av vurderingskriterier endret',
    en: 'Set of evaluation criteria changed',
  },
  vurderingskriteriumsamlingDeleteSuccess: {
    id: `${namespace}.vurderingskriteriumsamlingDeleteSuccess`,
    nb: 'Samling av vurderingskriterier slettet',
    en: 'Set of evaluation criteria deleted',
  },
  vurderingskriteriumCreateSuccess: {
    id: `${namespace}.vurderingskriteriumCreateSuccess`,
    nb: 'Vurderingskriterium opprettet',
    en: 'Evaluation criterion created',
  },
  vurderingskriteriumEditSuccess: {
    id: `${namespace}.vurderingskriteriumEditSuccess`,
    nb: 'Vurderingskriterium endret',
    en: 'Evaluation criterion changed',
  },
  vurderingskriteriumDeleteSuccess: {
    id: `${namespace}.vurderingskriteriumDeleteSuccess`,
    nb: 'Vurderingskriterium slettet',
    en: 'Evaluation criterion deleted',
  },
  vurderingskriteriumsamlingModalTitleEdit: {
    id: `${namespace}.vurderingskriteriumsamlingModalTitleEdit`,
    nb: 'Rediger samling av vurderingskriterier for ',
    en: 'Edit evaluation criteria set for ',
  },
  vurderingskriteriumsamlingModalTitleCreate: {
    id: `${namespace}.vurderingskriteriumsamlingModalTitleCreate`,
    nb: 'Ny samling av vurderingskriterier for ',
    en: 'New evaluation criteria set for ',
  },
  vurderingskriteriumsamlingModalNavnFieldLabel: {
    id: `${namespace}.vurderingskriteriumsamlingModalNavnFieldLabel`,
    nb: 'Navn på samling av vurderingskriterier',
    en: 'Name of evaluation criteria set',
  },
  vurderingskriteriumModalTitleEdit: {
    id: `${namespace}.vurderingskriteriumModalTitleEdit`,
    nb: 'Rediger vurderingskriteriet for ',
    en: 'Edit the evaluation criterion for ',
  },
  vurderingskriteriumModalTitleCreate: {
    id: `${namespace}.vurderingskriteriumModalTitleCreate`,
    nb: 'Nytt vurderingskriterium for ',
    en: 'New evaluation criterion for ',
  },
  vurderingskriteriumModalNavnFieldLabel: {
    id: `${namespace}.vurderingskriteriumModalNavnFieldLabel`,
    nb: 'Navn på vurderingskriterium ',
    en: 'Name of evaluation criterion',
  },
  beskrivelseFieldLabel: {
    id: `${namespace}.beskrivelseFieldLabel`,
    nb: 'Beskrivelse',
    en: 'Description',
  },
  vurderingsmetodeFieldLabel: {
    id: `${namespace}.vurderingsmetodeFieldLabel`,
    nb: 'Vurderingsmetode',
    en: 'Assessment method',
  },
  vurderingsmetodeValueLabel: {
    id: `${namespace}.vurderingsmetodeValueLabel`,
    nb: 'Fritekst',
    en: 'Custom',
  },
  buttonDeleteLabel: {
    id: `${namespace}.buttonDeleteLabel`,
    nb: 'Slett',
    en: 'Delete',
  },
  buttonCancelLabel: {
    id: `${namespace}.buttonCancelLabel`,
    nb: 'Avbryt',
    en: 'Cancel',
  },
  buttonSaveLabel: {
    id: `${namespace}.buttonSaveLabel`,
    nb: 'Lagre',
    en: 'Save',
  },
  buttonEditLabel: {
    id: `${namespace}.buttonEditLabel`,
    nb: 'Rediger',
    en: 'Edit',
  },
  buttonCreatesamlingLabel: {
    id: `${namespace}.buttonCreatesamlingLabel`,
    nb: 'Opprett samling',
    en: 'Create collection',
  },
  buttonEditsamlingLabel: {
    id: `${namespace}.buttonEditsamlingLabel`,
    nb: 'Rediger samling',
    en: 'Edit collection',
  },
  buttonCreateVurderingskriteriumLabel: {
    id: `${namespace}.buttonCreateVurderingskriteriumLabel`,
    nb: 'Opprett vurderingskriterium',
    en: 'Create criterion',
  },
  buttonEditVurderingskriteriumLabel: {
    id: `${namespace}.buttonEditVurderingskriteriumLabel`,
    nb: 'Rediger vurderingskriterium',
    en: 'Edit criterion',
  },
};

export default translations;
